import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { SiteSettingsService } from '@shared/services/site-settings.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RootRouteGuard {
  constructor(
    private router: Router,
    private siteSettingsService: SiteSettingsService
  ) {}

  public canActivate(route: ActivatedRouteSnapshot, routerState: RouterStateSnapshot): Observable<boolean> {
    return this.getSiteSettings();
  }

  public getSiteSettings(): Observable<boolean> {
    return this.siteSettingsService.fetchSiteSettings().pipe(
      map((data) => {
        this.router.navigate([data.fe_configuration.root_route]);
        return false;
      })
    );
  }
}
